import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreakpointsDirective } from './breakpoints.directive';
import { LayoutService } from '@shared/services';

@NgModule({
  declarations: [BreakpointsDirective],
  exports: [BreakpointsDirective],
  imports: [
    CommonModule
  ],
  providers: [
    LayoutService
  ]
})
export class BreakpointsModule { }
